
<v-group>
  <v-rect :zIndex='2' v-if="table.forme === 'rect'" ref="miniRect" :config="configMiniRectangle"></v-rect>
  <v-circle :zIndex='3' v-if="table.forme === 'circle'" ref="miniCircle" :config="configMiniCircle"></v-circle>
</v-group>
